import { useState } from 'react';
import { RestClient } from 'nordic/restclient';

const restclient = RestClient({
  timeout: 3000,
});


/* istanbul ignore next */
export const useEditEmail = () => {
  const [isLoading, setIsLoading] = useState(false);

  const updateDeclaredEmail = async (urlToDeclaredEmail: string): Promise<string> => {
    try {
      setIsLoading(true);
      const res = await restclient.put(urlToDeclaredEmail!);
      return res.data.uri;
    } catch (e) {
      throw new Error();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateDeclaredEmail,
    isLoading,
  };
};

